<template>
	<div class="comp">
		<div class="title">
			<div class="titleL">宠物订单</div>
			<div class="titleR">
			</div>
		</div>
		<div class="tableBox">
			<div class="tableItem" v-for="(item,index) in tableData" :key="index">
				<div class="orderTitle">
					<div class="orderNum">单号：{{item.no}}</div>
					<div class="orderDate">{{$public.FTime(item.create_time)}}</div>
				</div>
				<div class="orderCon">
					<img :src="item.order_item_list[0].remarks" class="petImg"/>
					<div class="petMsg">
						<div class="petMsgItem">{{item.order_item_list[0].goods_name}}</div>
						<div class="petMsgItem">宠物ID：{{item.order_item_list[0].order_item_goods_list[0].custom_code}}</div>
						<!-- <div class="petMsgItem">年龄：{{item.order_item_list[0].goods_name}}</div>
						<div class="petMsgItem">性别：{{item.order_item_list[0].goods_name}}</div> -->
						<div class="petMsgItem">售后保障：{{item.online_order_data&&item.online_order_data.safeguard_type&&item.online_order_data.safeguard_type.name}}</div>
						<div class="petMsgItem">运费：{{item.postage}}</div>
					</div>
					<div class="petMoney">
						<div class="petMoneyItem">单价：{{item.order_item_list[0].price}}</div>
						<div class="petMoneyItem">数量：1</div>
						<div class="petMoneyItem">订单金额：{{item.order_item_list[0].total_price}}</div>
						<div class="petMoneyItem">支付方式：{{FPayMethod(item)}}</div>
					</div>
					<div class="petOperation">
						<div class="petBtn" v-if="item.state===1||item.state===2" @click="curRow=item;dialogPayMethod_state=true">继续支付</div>
						<div class="petBtn" v-if="item.state===-2" style="background-color: #F6F6F8;border-color:#E8E8EB;color:#9F9FAC;">交易关闭</div>
						<div class="petBtn" v-if="item.state===3" style="background-color: #F6F6F8;border-color:#E8E8EB;color:#9F9FAC;">支付完成</div>
						<div class="petBtn" v-if="item.state===5" style="background-color: #F6F6F8;border-color:#E8E8EB;color:#9F9FAC;">已发货</div>
						<div class="petBtn" v-if="item.state===8" style="background-color: #F6F6F8;border-color:#E8E8EB;color:#9F9FAC;">已收货</div>
					</div>
				</div>
			</div>
			<div style="text-align: right;">
				<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
			</div>
		</div>
		<div v-if="dialogPayMethod_state">
			<dialogPayMethod @submit="submit_dialogPayMethod"></dialogPayMethod>
		</div>
		<div v-if="dialogQRCode_state">
			<dialogQRCode :QRCode="wexinPay" :orderNum="orderNum" @submit="wexinPay='';dialogQRCode_state=false"></dialogQRCode>
		</div>
		<div v-html="alipay" ref="alipayDiv"></div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import dialogPayMethod from "./dialog_payMethod.vue"
	import dialogQRCode from "../../../components/dialogQRCode.vue"
	export default {
		components:{page,dialogPayMethod,dialogQRCode},
		data() {
			return {
				
				page:{
					page:1,
					pageSize:4,
					total:0,
				},
				tableData:[],
				
				// 支付
				dialogPayMethod_state:false,
				curRow:{},
				dialogQRCode_state:false,
				wexinPay:'',
				orderNum:'', // 订单编号
				alipay:'',
				
			}
		},
		mounted(){
			this.getTableData()
		},
		methods:{
			see(row){
				console.log(row)
			},
			submit_dialogPayMethod(obj){
				this.dialogPayMethod_state=false;
				if(obj.type==='success'){
					this.$http.post(process.env.VUE_APP_livingMall+'/api/Order/OrderPay', {
						"order_no": this.curRow.no,
						"money": this.curRow.total_price,
						"yue_money": 0,
						"type": obj.data,
						"openid": "",
					}).then(res1 => {
						if(res1.code===0){
							if(obj.data===1){
								this.wexinPay = res1.data
								this.orderNum = this.curRow._id;
								this.$nextTick(()=>{
									this.dialogQRCode_state=true
								})
							}else if(obj.data===2){
								this.alipay = res1.data.substr(0,res1.data.length-57)
								this.$nextTick(()=>{
									this.$refs.alipayDiv.children[0].submit()
								})
							}
						}
					})
				}
			},
			// 微信支付完成
			submit_dialogQRCode(obj){
				this.wexinPay='';
				this.orderNum="";
				this.dialogQRCode_state=false
				if(obj.type==='success'){
					// this.$router.replace({path:'/order/livingOrderResult?no='+this.orderNum})
					this.getTableData()
				}
			},
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//获取表格
			getTableData(){
				let params = {
					"state": -1,  // 状态 -1 全部 11 待付款 12 待发货 13待收货 14 待评价 15退货
					"starttime": "",
					"endtime": "",
					"screen_time": "",  // 筛选时间
					"shop_id": "",  // 店铺编号
					"keyword": "",
					"is_score": 2,  // 积分订单 1 积分订单 2 非积分订单
					"is_can_fefund": 0,  // 是否可以退款
					order_type_id: 8, // 单类型 -1 全部 1. 商品 2.洗美 3.病例 4. 疫苗驱虫 5.医疗服务 6 寄养 7 挂号 8 活体 9 虚拟类 10 定金 11 大礼包
					page_index:this.page.page,
					page_size:this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_livingMall+'/api/Order/GetOrderList', params).then(res => {
					loading.close()
					if(res.code == 0){
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			FPayMethod(item){
				if(this.$public.isNull(item.pay_info)){
					return ''
				}else{
					for(let i=0;i<item.pay_info.pay_list.length;i++){
						if(item.pay_info.pay_list[i].pay_type===1){
							return '支付宝'
						}
						if(item.pay_info.pay_list[i].pay_type===2){
							return '微信'
						}
					}
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
.comp{
	height:100%;
	.title{
		display: flex;justify-content: space-between;padding:0 0 10px;border-bottom: 1px solid #E8E8EB;
		.titleL{
			font-size: 20px;color:#303042;padding-left:10px;line-height: 28px;
		}
		.titleR{
			
		}
	}
	.tableBox{
		height: calc(100% - 88px);
		.tableItem{
			height: 262px;border:1px solid #E8E8EB;box-sizing: border-box;margin-top:32px;
			.orderTitle{
				background-color: #F6F6F8;border-bottom:1px solid #E8E8EB;height: 62;display: flex;justify-content: space-between;padding:0 36px;
				.orderNum{
					font-size: 18px;color:#303042;line-height: 62px;
				}
				.orderDate{
					font-size: 18px;color:#5F5F72;line-height: 62px;
				}
			}
			.orderCon{
				display: flex;padding:24px 36px;
				.petImg{
					width:120px;height: 120px;margin-right: 40px;
				}
				.petMsg{
					width:280px;
					.petMsgItem{
						margin-bottom:18px;font-size: 16px;colro:#303042;
					}
				}
				.petMoney{
					width:220px;
					.petMoneyItem{
						margin-bottom:18px;font-size: 16px;colro:#303042;
					}
				}
				.petOperation{
					width:150px;
					.petBtn{
						font-size: 18px;color:#303042;background-color: #FCD000;line-height: 48px;width:128px;border-radius: 24px;text-align: center;cursor: pointer;margin:40px auto;
					}
				}
			}
		}
	}
}
</style>							
